export const exhibitorInspectorKeys = {
  all: ["exhibitor-inspector"] as const,
  byExhibitorId: (exhibitorId: string, eventId: string) =>
    [
      ...exhibitorInspectorKeys.all,
      "by-exhibitor-id",
      exhibitorId,
      eventId,
    ] as const,
};
